import { CreateElement, RenderContext, VNode } from 'vue';
import { Dictionary } from '../../utils';

const DYNAMIC_CLASSES = Symbol('add-class-to-slot');

function arrarizeClassProperty(vnode: VNode) {
  if (!Array.isArray(vnode.data.class)) {
    vnode.data.class = vnode.data.class ? [vnode.data.class] : [];
  }
}

function addStaticClass(staticClass: string, vnode: VNode) {
  if (!vnode.data.class.includes(staticClass)) {
    vnode.data.class.push(staticClass);
  }
}

function addNewDynamicClasses(dynamicClasses: Dictionary<boolean>, { data }: VNode) {
  // We add a private property to dynamicClasses object, to flag it as our dynamicClasses.
  // This way we can find it in data.class, and then replace it in the re-render cycles
  Object.defineProperty(dynamicClasses, DYNAMIC_CLASSES, { value: true, writable: false, enumerable: false });
  const dynamicClassesIndex = (data.class as any[]).findIndex(vueClass => vueClass[DYNAMIC_CLASSES]);
  if (dynamicClassesIndex !== -1) {
    data.class[dynamicClassesIndex] = dynamicClasses;
  } else {
    data.class.push(dynamicClasses);
  }
}

export default {
  functional: true,
  render(createElement: CreateElement, { props, slots, data }: RenderContext) {
    const defaultSlot = slots().default ?? [];
    defaultSlot.forEach((vnode: VNode, index: number) => {
      arrarizeClassProperty(vnode);
      if (data.staticClass) {
        addStaticClass(data.staticClass, vnode);
      }
      if (props.dynamicClass || data.class) {
        const dynamicClasses = Object.assign({}, data.class, props.dynamicClass(vnode, index));
        addNewDynamicClasses(dynamicClasses, vnode);
      }
    });
    return defaultSlot;
  }
} as any;
